/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneProse from 'base/components/standalone/Prose';

export const DynamicStandaloneProse = StandaloneProse;
export type DynamicStandaloneProseProps = PropsFromComponent<typeof StandaloneProse>;

export const DynamicStandaloneProseWith = (extras: DynamicStandaloneExtras): typeof StandaloneProse => {
    return function DynamicStandaloneProse(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Prose');
        return <StandaloneProse {...mergeProps({ options: { theme } }, props)} />;
    }
}